import React from 'react';
import { arrayOf, string, bool } from 'prop-types';
import { propTypes } from '../../util/types';
import { FormattedMessage } from '../../util/reactIntl';
import { Icon, NamedLink } from '../../components';
import classNames from 'classnames';
import config from '../../config';

import css from './SectionJoin.module.css';

const SectionJoin = props => {
  const { rootClassName, className, currentUser, listings, queryListingsInProgress } = props;
  const classes = classNames(css.root, rootClassName, className);

  // Anonymous visitors always see the join banner — their eligibility
  // doesn't depend on the watchlist query, so don't blink the section
  // out during post-hydration refetches. Logged-in users only see it
  // once the query confirms an empty watchlist (unchanged).
  const showSection = !currentUser || (!queryListingsInProgress && listings.length === 0);

  return showSection ? (
    <div className={classes}>
      <h2 className={css.title}>
        <FormattedMessage id="SectionJoin.title" />
      </h2>
      <div className={css.content}>
        <Icon name="bookmark" size={48} className={css.icon} />
        <h3 className={css.heading}>
          <FormattedMessage id="SectionJoin.heading" />
        </h3>
        <p className={css.subHeading}>
          <FormattedMessage id="SectionJoin.subHeading" />
        </p>
        {currentUser ? null : (
          <NamedLink
            name="SignupPage"
            params={{ role: config.userRoles['audience'] }}
            className={css.button}
          >
            <FormattedMessage id="SectionJoin.buttonText" />
          </NamedLink>
        )}
      </div>
    </div>
  ) : null;
};

SectionJoin.defaultProps = {
  rootClassName: null,
  className: null,

  queryListingsInProgress: false,
};

SectionJoin.propTypes = {
  rootClassName: string,
  className: string,

  currentUser: propTypes.currentUser,
  listings: arrayOf(propTypes.listing),
  queryListingsInProgress: bool.isRequired,
};

export default SectionJoin;
